import Swiper from 'swiper';

const moduleName = 'smartphone';

export function smartphone() {

    Array.from(document.querySelectorAll('.js-smartphone')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const smartphone = self;
        const SWIPER_BREAKPOINT = 1190;
        const smartphoneButtons = smartphone.querySelectorAll('.js-smartphone-button');
        const smartphoneSlider = smartphone.querySelector('.js-smartphone-slider');
        const smartphoneSliderWrapper = smartphone.querySelector('.js-smartphone-slider-wrapper');
        const smartphoneItems = smartphone.querySelectorAll('.js-smartphone-item');
        const smartphonePrevButton = smartphone.querySelector('.js-smartphone-prev-button');
        const smartphoneNextButton = smartphone.querySelector('.js-smartphone-next-button');
        const smartphoneSwiperOptions = {
            loop: true,
            simulateTouch: false,
            slideActiveClass: '_active',
            autoHeight: true,
            navigation: {
                prevEl: smartphonePrevButton,
                nextEl: smartphoneNextButton
            }
        };
        let smartphoneSwiper;
        let smartphoneActiveItemIndex;

        initSmartphoneSwiper();

        Array.from(smartphoneButtons).forEach((smartphoneButton) => {
            smartphoneButton.addEventListener('click', () => {
                if (smartphoneButton.classList.contains('_active') || document.body.clientWidth < SWIPER_BREAKPOINT) return;

                const activeSmartphoneItem = smartphone.querySelector('.js-smartphone-item._active');
                const smartphoneItem = smartphoneButton.closest('.js-smartphone-item');

                activeSmartphoneItem.classList.remove('_active');
                smartphoneItem.classList.add('_active');
            });
        });

        window.addEventListener('resize', initSmartphoneSwiper);



        function initSmartphoneSwiper() {
            if (document.body.clientWidth < SWIPER_BREAKPOINT && typeof smartphoneSwiper != 'object') {
                smartphoneSlider.classList.add('swiper-container');
                smartphoneSliderWrapper.classList.add('swiper-wrapper');
                Array.from(smartphoneItems).forEach((smartphoneItem) => smartphoneItem.classList.add('swiper-slide'));
                smartphoneSwiperOptions.initialSlide = getSmartphoneActiveItemIndex();

                smartphoneSwiper = new Swiper(smartphoneSlider, smartphoneSwiperOptions);
            } else if (document.body.clientWidth >= SWIPER_BREAKPOINT && typeof smartphoneSwiper == 'object') {
                smartphoneActiveItemIndex = getSmartphoneActiveItemIndex();

                smartphoneSwiper.destroy();
                smartphoneSlider.classList.remove('swiper-container');
                smartphoneSliderWrapper.classList.remove('swiper-wrapper');

                Array.from(smartphoneItems).forEach((smartphoneItem, index) => {
                    smartphoneItem.classList.remove('swiper-slide');
                    if (index == smartphoneActiveItemIndex) smartphoneItem.classList.add('_active');
                });

                smartphoneSwiper = undefined;
            }
        }

        function getSmartphoneActiveItemIndex() {
            const smartphoneActiveItem = smartphone.querySelector('.js-smartphone-item._active');

            if (smartphoneActiveItem) {
                return Array.from(smartphoneItems).indexOf(smartphoneActiveItem);
            } else {
                return 0;
            }
        }
    });

}